import { render, staticRenderFns } from "./InstructActivateGeolocation.vue?vue&type=template&id=5ebfc05f&scoped=true&"
import script from "./InstructActivateGeolocation.vue?vue&type=script&lang=js&"
export * from "./InstructActivateGeolocation.vue?vue&type=script&lang=js&"
import style0 from "./InstructActivateGeolocation.vue?vue&type=style&index=0&id=5ebfc05f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebfc05f",
  null
  
)

export default component.exports